import Header from "../../HeaderSimple/HeaderSimple.vue"
import ResponsiveFooter from "../..//responsivefooter/ResponsiveFooter.vue"
import TitleBox from "../TitleBox/TitleBox.vue"
import Portfolio from "../Portfolio/Portfolio.vue"
import Performance from "../Performance/Performance.vue"
import Diversification from "../Diversification/Diversification.vue"
import RegisterButton from "../RegisterButton/RegisterButton.vue"
import '..//..//..//mixins.js'
import CookieLaw from 'vue-cookie-law'
import {get} from "axios";
import { mapActions } from "vuex"
import spinner from "../../LoadingComponent/LoadingComponent.vue"
import SideBar from "../../SideBar/SideBar.vue"

export default {
  name: 'portfolio-dashboard',
  metaInfo: {
    title: 'Jemand teilt sein Depot mit dir',
  },
  components: {
    Header: Header,
    responsivefooter: ResponsiveFooter,
    Portfolio: Portfolio,
    Performance: Performance,
    Diversification: Diversification,
    TitleBox: TitleBox,
    RegisterButton: RegisterButton,
    CookieLaw,
    spinner,
    SideBar
  },
  props: [],
  data () {
    return {
      tokenValid:false,
      showPortfolio:null,
      id:this.$route.params.id,
      isDataLoaded: false,
      portfolio: [],
      isPortfolioEmpty: false,

    }
  },
  computed: {

  },
  async created () {
    this.verifyTokenNoRouting();
    this.enablePlugin();
    await get("https://user.sigmafol.io/sharedPortfolios/?format=json&id=" + this.id)
    .then(response => {
      console.log("Data loaded", response)
      this.showPortfolio = response;

    }).catch(err => {
        console.log(err)
    })
    if(this.showPortfolio){
      await this.$store.dispatch('load_SP_portfolioData', this.id, this.tokenValid)
      this.isDataLoaded = true;
    }
    

 },
  mounted () {

  },
  watch: { // function that monitors if variable is token is valid
    showPortfolio: function (val) {
      if (val == true){
        console.log("Data loaded")
          this.loadData();
          window.addEventListener("resize", this.myEventHandler);
      }
      else if (val == false){
        this.$router.push("/portfolios");
      } 
    }
  },

  methods: {
    ...mapActions(['load_SP_portfolioData'])
  }
}


